(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nkc-ribbon-type-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRoot = (root) => {
      if (!root || root.dataset.nkcCarouselReady === 'true') return;

      const track = root.querySelector('[data-nkc-track]');
      const progress = root.querySelector('[data-nkc-progress]');
      const prev = root.querySelector('[data-nkc-prev]');
      const next = root.querySelector('[data-nkc-next]');

      if (!track) return;
      root.dataset.nkcCarouselReady = 'true';

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const ratio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        const progressValue = maxScroll > 0 ? Math.min(1, Math.max(0, track.scrollLeft / maxScroll)) : 0;

        if (progress) {
          const thumbWidth = Math.max(18, ratio * 100);
          const maxLeft = 100 - thumbWidth;
          progress.style.width = `${thumbWidth}%`;
          progress.style.left = `${maxLeft * progressValue}%`;
        }

        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      };

      const step = (direction) => {
        const card = track.querySelector('.nkc-ribbon-type-card-wrap');
        if (!card) return;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const amount = card.getBoundingClientRect().width + gap;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });

      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);

      update();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll?.('[data-nkc-ribbon-types]').forEach(initRoot);
      if (scope.matches?.('[data-nkc-ribbon-types]')) initRoot(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
